import PdaTitle from '../../component/common/PdaTitle'
import React, { useCallback, useContext, useRef, useState } from 'react'
import { useMountEffect } from 'primereact/hooks'
import { useLocation, useNavigate } from 'react-router-dom'
import { InputText } from 'primereact/inputtext'
import { InventorySurveyInfo } from '../../types/inventory'
import { includeComma, markDayHyphen } from '../../utils/inputText'
import { CommonContext } from '../../component/common/context/commonContext'
import { includes } from 'lodash'
import { useTranslation } from 'react-i18next'
import { tokens } from 'locales/tokens'

const InventorySurvey = () => {
    const { $toast, $http } = useContext(CommonContext)
    const { t } = useTranslation()
    const scanRef = useRef<HTMLInputElement>(null)
    const [searchText, setSearchText] = useState<string>('')
    const navigate = useNavigate()
    const location = useLocation()
    const [inventorySurveyInfo, setInventorySurveyInfo] = useState<InventorySurveyInfo>()
    const [percent, setPercent] = useState<number>(0)
    useMountEffect(() => {
        if (scanRef && scanRef.current) {
            scanRef.current.focus()
        }
        find()
        console.log('재고조사', location.state)
        // if (location.state.inventorySurveyInfo) {
        //     setInventorySurveyInfo(location.state.inventorySurveyInfo)
        // }
        // if (location.state.percent) {
        //     setPercent(location.state.percent)
        // }
    })

    // console.log(navigate)

    const find = useCallback(async () => {
        await $http()
            .get('/inventory-survey')
            .then((res: InventorySurveyInfo) => {
                setInventorySurveyInfo(res)
                setPercent(Math.round((Number(res?.completeCnt) / Number(res?.ttlLctCnt)) * 100))
            })
    }, [$http])

    const onKeyDownSearch = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter') {
            setSearchText('')
            if (includes(inventorySurveyInfo?.lctSeqs, searchText)) {
                navigate('/inventory-survey-location-detail', {
                    state: {
                        lctSeq: searchText,
                        invnsuId: inventorySurveyInfo?.invnsuId,
                    },
                })
            } else {
                $toast({ title: t(tokens.common.fail), text: t(tokens.inventory.location_information_not_found), icon: 'error' })
            }
        }
    }

    return (
        <div>
            <PdaTitle title={t(tokens.common.inventory_investigation)} historyBack goToHome />
            <div className="col-12 flex">
                <InputText
                    ref={scanRef}
                    value={searchText}
                    className="p-inputtext-md w-full"
                    placeholder={t(tokens.inventory.please_scan_location_barcode)}
                    onChange={(e) => setSearchText(e.currentTarget.value)}
                    onKeyDown={(e) => onKeyDownSearch(e)}
                />
            </div>
            <div className="grid w-full">
                <div className={`col-12 font-bold text-6xl text-center ${percent === 100 ? 'rdms-text-success' : 'rdms-text-warning'}`}>
                    {t(tokens.common.inventory_audit)} {percent === 100 ? t(tokens.common.complete) : t(tokens.common.in_progress)}
                </div>
                <div className="col-12 font-bold text-xl pt-0">
                    <span className="rdms-text-primary ml-4">{t(tokens.inventory.inventory_survey_date)}</span>
                    <span className="ml-4">{markDayHyphen(inventorySurveyInfo?.srvyStartYmd)}</span>
                </div>
                <div className="col-12 font-bold text-lg pt-2 pb-0">
                    <span className="ml-4">* {t(tokens.inventory.inventory_survey_progress)}</span>
                </div>
                <div className="card w-full m-2 ml-4 my-1 p-3">
                    <div className="col-12 text-center text-7xl font-bold rdms-text-danger">{percent} %</div>
                    <div className="col-12 flex justify-content-between text-3xl font-bold">
                        <div>{t(tokens.common.total)}</div>
                        <div>{includeComma(inventorySurveyInfo?.ttlLctCnt, '-')}</div>
                    </div>
                    <div className="col-12 flex justify-content-between text-3xl font-bold rdms-text-success">
                        <div>{t(tokens.common.complete)}</div>
                        <div>{includeComma(inventorySurveyInfo?.completeCnt, '-')}</div>
                    </div>
                    <div className="col-12 flex justify-content-between text-3xl font-bold rdms-text-warning">
                        <div>{t(tokens.common.remaining)}</div>
                        <div>{includeComma(Number(inventorySurveyInfo?.ttlLctCnt) - Number(inventorySurveyInfo?.completeCnt), '-')}</div>
                    </div>
                </div>
                <div className="col-12 font-bold text-xl text-right pt-1">
                    <span className="mr-2">
                        * {t(tokens.common.total_sum)} {includeComma(inventorySurveyInfo?.skuCnt, '-')} SKU
                    </span>
                </div>
            </div>
        </div>
    )
}

export default InventorySurvey
